import { render } from "./KeyResult.vue?vue&type=template&id=275f8dfe&scoped=true"
import script from "./KeyResult.vue?vue&type=script&lang=js"
export * from "./KeyResult.vue?vue&type=script&lang=js"

import "./KeyResult.vue?vue&type=style&index=0&id=275f8dfe&lang=scss&scoped=true"
import "./KeyResult.vue?vue&type=style&index=1&id=275f8dfe&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275f8dfe"]])

export default __exports__